
export const methodData = [
    { name: "Afficher les données brutes", id: "raw" },
    { name: "Afficher les données aggrégées horaires", id: "1h" },
    { name: "Afficher les données aggrégées journalières", id: "1d" },
]

export const methodDataWithoutRaw = [
    { name: "Afficher les données aggrégées horaires", id: "1h" },
    { name: "Afficher les données aggrégées journalières", id: "1d" },
]

export const displayData = [
    { name: "Afficher les données en tableau", id: "tab" },
    { name: "Afficher les données en courbe", id: "linechart" },
    { name: "Afficher les données en histogramme", id: "barchart" },
]

export const displayDataOnlyTab = [
    { name: "Afficher les données en tableau", id: "tab" },
]

export const monthnameData = [
    { name: "Janvier", id: "January"},
    { name: "Février", id: "February"},
    { name: "Mars", id: "March"},
    { name: "Avril", id: "April"},
    { name: "Mai", id: "May"},
    { name: "Juin", id: "June"},
    { name: "Juillet", id: "July"},
    { name: "Août", id: "August"},
    { name: "Septembre", id: "September"},
    { name: "Octobre", id: "October"},
    { name: "Novembre", id: "November"},
    { name: "Décembre", id: "December"},
    { name: "Janvier", id: "janvier"},
    { name: "Février", id: "février"},
    { name: "Mars", id: "mars"},
    { name: "Avril", id: "avril"},
    { name: "Mai", id: "mai"},
    { name: "Juin", id: "juin"},
    { name: "Juillet", id: "juillet"},
    { name: "Août", id: "août"},
    { name: "Septembre", id: "septembre"},
    { name: "Octobre", id: "octobre"},
    { name: "Novembre", id: "novembre"},
    { name: "Décembre", id: "décembre"},
]